import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appI18nicSelect]',
})
export class I18nicSelectDirective {
  constructor() {}

  /** Cambia valores del inglés al español en los componente de Ionic: ion-select */
  @HostBinding('attr.placeholder') placeholder = 'Seleccione';
  @HostBinding('attr.cancel-text') cancelText = 'Cancelar';
  @HostBinding('attr.ok-text') okText = 'Aceptar';
}
